import { PropsWithChildren } from 'react';
import styles from './StickyHeader.module.scss'
import { CSSProperties } from 'react';

type TProps = {
	height?: string
	backgroundColor?: string
}

export const StickyHeader = (props: PropsWithChildren<TProps>) => {
	const {
		height = '70px',
		backgroundColor = 'var(--neutral-00)',
		children
	} = props;

	const setStyles = () => {
		const styles: CSSProperties = {}
		styles['height'] = height
		styles['backgroundColor'] = backgroundColor;
		return styles;
	}

	return (
		<header className={styles.header} style={setStyles()} data-testid='@Ofload-StickyHeader'>
			{children}
		</header>
	)
}